<ng-container *ngIf="!loading && !error && !empty && activity as item; else activityState">
  <section
    class="last-activity"
    data-section-id="homeia_component_last_activity"
    *ngIf="!compactLauncher; else activityLauncher"
  >
    <div class="eyebrow-row">
      <p class="section-eyebrow">{{ lang.translate('home.lastActivity.eyebrow') }}</p>
    </div>
    <h2>{{ lang.translate('home.lastActivity.title') }}</h2>
    <p class="connection-copy">{{ lang.translate('home.lastActivity.connection') }}</p>

    <ng-container [ngTemplateOutlet]="activityContent"></ng-container>
  </section>

  <ng-template #activityLauncher>
    <section class="last-activity last-activity--launcher" data-section-id="homeia_component_last_activity_launcher">
      <div class="eyebrow-row eyebrow-row--between">
        <p class="section-eyebrow">{{ lang.translate('home.lastActivity.eyebrow') }}</p>
        <button type="button" class="last-activity__launcher-link" (click)="onOpenActivity()">
          {{ lang.translate('home.lastActivity.openPanel') }}
        </button>
      </div>
      <div class="last-activity__launcher-headline">
        <h2>{{ lang.translate('home.lastActivity.title') }}</h2>
        <p class="connection-copy">{{ lang.translate('home.lastActivity.connection') }}</p>
      </div>

      <button
        type="button"
        class="last-activity__launcher-card"
        *ngIf="previewHistory[0] as latest"
        (click)="onOpenActivity()"
      >
        <div class="activity-preview__meta">
          <span class="type-pill" [attr.data-importance]="getActivityDisplay(latest).importance">{{ getActivityDisplay(latest).title }}</span>
          <span class="timestamp">{{ latest.timestamp | date: 'short' }}</span>
          <span class="activity-preview__signal" *ngIf="getActivityDisplay(latest).signalLabel as signalLabel">{{ signalLabel }}</span>
        </div>
        <p class="activity-preview__description">{{ getActivityDisplay(latest).summary }}</p>
        <span class="last-activity__launcher-cta">{{ lang.translate('home.lastActivity.openPanel') }}</span>
      </button>
    </section>
  </ng-template>

  <ng-container *ngIf="compactLauncher && (activityExpanded$ | async)">
    <div class="activity-overlay" (click)="onCloseActivity()">
      <section
        class="activity-panel"
        data-section-id="homeia_component_activity_modal"
        (click)="onActivityPanelInteraction($event)"
      >
        <header class="panel-header">
          <div>
            <p class="panel-eyebrow">{{ lang.translate('home.lastActivity.eyebrow') }}</p>
            <h3>{{ lang.translate('home.lastActivity.title') }}</h3>
            <p class="connection-copy">{{ lang.translate('home.lastActivity.connection') }}</p>
          </div>
          <button
            type="button"
            class="panel-close"
            (click)="onCloseActivity()"
            [attr.aria-label]="lang.translate('home.lastActivity.closePanel')"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </header>

        <ng-container [ngTemplateOutlet]="activityContent"></ng-container>
      </section>
    </div>
  </ng-container>
</ng-container>

<ng-template #activityContent>
  <section class="activity-preview" data-section-id="homeia_component_activity_preview" *ngIf="previewHistory.length">
    <div class="activity-preview__header">
      <h3>{{ lang.translate('home.lastActivity.previewTitle') }}</h3>
      <span>{{ lang.translate('home.lastActivity.previewSubtitle') }}</span>
    </div>
    <ul class="activity-preview__list" data-section-id="homeia_component_activity_preview_list">
      <li
        class="activity-preview__item"
        *ngFor="let event of previewHistory; let idx = index"
        [attr.data-section-id]="'homeia_component_activity_preview_item_' + idx"
      >
        <div class="activity-preview__main">
          <div class="activity-preview__meta">
            <span class="type-pill" [attr.data-importance]="getActivityDisplay(event).importance">{{ getActivityDisplay(event).title }}</span>
            <span class="timestamp">{{ event.timestamp | date: 'short' }}</span>
            <span class="activity-preview__signal" *ngIf="getActivityDisplay(event).signalLabel as signalLabel">{{ signalLabel }}</span>
          </div>
          <p class="activity-preview__description">{{ getActivityDisplay(event).summary }}</p>
        </div>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="onActivityCardClick(event)"
        >
          {{ getPreviewActionLabel(event) }}
        </button>
      </li>
    </ul>
    <div class="activity-preview__cta">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onViewHistory()">
        {{ lang.translate('home.lastActivity.historyLink') }}
      </button>
    </div>
  </section>

  <section class="activity-detail" data-section-id="homeia_component_activity_detail" *ngIf="(activityDetail$ | async) as detail">
    <div class="activity-detail__header">
      <div class="activity-preview__meta">
        <span class="type-pill" [attr.data-importance]="getActivityDisplay(detail).importance">{{ getActivityDisplay(detail).title }}</span>
        <span class="timestamp">{{ detail.timestamp | date: 'short' }}</span>
      </div>
      <button type="button" class="btn btn-link btn-sm" (click)="onCloseDetail()">
        {{ lang.translate('common.close') }}
      </button>
    </div>
    <p class="activity-detail__description">{{ getActivityDisplay(detail).summary }}</p>
    <div class="detail-grid">
      <div *ngIf="getActivityDisplay(detail).documentsSummary as documentsSummary">
        <p class="detail-label">{{ lang.translate('home.lastActivity.documentsImpacted') }}</p>
        <p class="detail-value">{{ documentsSummary }}</p>
      </div>
      <div>
        <p class="detail-label">{{ lang.translate('home.lastActivity.queueImpacted') }}</p>
        <p class="detail-value">{{ getActivityDisplay(detail).impactSummary }}</p>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #activityState>
  <div class="error-state" *ngIf="error; else activityNonError">
    <p class="error-title">{{ error.title }}</p>
    <p class="error-message">{{ error.message }}</p>
    <div class="error-actions">
      <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
        {{ lang.translate('home.general.retry') }}
      </button>
      <span class="retry-after" *ngIf="error.retryAfterSeconds">
        {{ lang.translate('home.general.retryAfter') }} {{ error.retryAfterSeconds }}s
      </span>
    </div>
  </div>
  <ng-template #activityNonError>
    <div class="empty-state" *ngIf="empty; else activityLoading">
      {{ lang.translate('home.lastActivity.empty') }}
    </div>
    <ng-template #activityLoading>
      <div class="last-activity loading" role="status">{{ lang.translate('home.general.loading') }}</div>
    </ng-template>
  </ng-template>
</ng-template>

<ng-container *ngIf="(historyPanelOpen$ | async) && !loading && !error">
  <div class="history-overlay" (click)="onCloseHistory()">
    <section class="history-panel" data-section-id="homeia_dashboard_activity_history_panel" (click)="onHistoryPanelInteraction($event)">
      <header class="panel-header">
        <div>
          <p class="panel-eyebrow">{{ lang.translate('home.lastActivity.historyEyebrow') }}</p>
          <h3>{{ lang.translate('home.lastActivity.historyTitle') }}</h3>
        </div>
        <button type="button" class="panel-close" (click)="onCloseHistory()" [attr.aria-label]="lang.translate('home.lastActivity.closeHistory')">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>
      <div class="history-body" data-section-id="homeia_dashboard_activity_history_list" *ngIf="history?.length; else emptyHistory">
        <article
          class="history-card"
          *ngFor="let event of history; let idx = index"
          [attr.data-section-id]="'homeia_dashboard_activity_history_item_' + idx"
          (click)="onSelectHistory(event)"
        >
          <div class="history-meta">
            <span class="history-type">{{ lang.translate('home.lastActivity.type.' + event.type) }}</span>
            <span class="timestamp">{{ event.timestamp | date: 'short' }}</span>
          </div>
          <p class="history-description">{{ event.description }}</p>
        </article>
      </div>
      <div class="history-loading" *ngIf="historyLoading">
        {{ lang.translate('home.general.loading') }}
      </div>
      <div class="history-pagination" *ngIf="historyTotalPages > 1">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="onHistoryPrev()"
          [disabled]="historyPage <= 1 || historyLoading"
        >
          {{ lang.translate('home.pagination.previous') }}
        </button>
        <span class="page-info">{{ historyPage }} / {{ historyTotalPages }}</span>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="onHistoryNext()"
          [disabled]="historyPage >= historyTotalPages || historyLoading"
        >
          {{ lang.translate('home.pagination.next') }}
        </button>
      </div>
    </section>
  </div>
</ng-container>

<ng-template #emptyHistory>
  <p class="empty-state">{{ lang.translate('home.lastActivity.historyEmpty') }}</p>
</ng-template>

